<div class="hra-diagram">
  <svg viewBox="250 440 720 700" xmlns="http://www.w3.org/2000/svg">
    <image href="assets/images/hra-diagram.jpg" x="0" y="0" width="1284" height="1297" />
    <polygon *ngFor="let c of cells"
             [attr.points]="c.points"
             class="hra-cell"
             [class.on]="isOn(c.id)"
             [class.readonly]="readonly"
             (click)="toggle(c.id)" />
  </svg>
  <button type="button" class="hra-clear" *ngIf="!readonly && value" (click)="clear()">Clear</button>
</div>
